module.exports = __webpack_public_path__ + "img/interviewProcess-icon.606a04aa.svg";